export const MIN_SEARCH_VALUE_LENGTH = 2;
export const PROVIDERS_SEARCH_LC_KEY = 'providersSearchResults';
export const MODAL_SEARCH = 'modalSearch';
